import React from 'react'
import useTranslate from 'modules/local/useTranslate'

// Đánh dấu "Linh Mục" - hiện khi thành viên đã lãnh nhận Truyền Chức (is_priest, tính sẵn ở BE qua
// family_book_member_sacraments, xem FamilyBookController::getMyFamilyForests()/
// FamilyBookMemberTransformer(Tiny)). Dùng chung cho MỌI nơi hiện tên thành viên trong phân hệ Sổ
// Gia Đình (Cây Gia Phả, Phả Hệ đầy đủ, list Thành Viên, Hồ Sơ...) - không tự chế badge riêng mỗi
// nơi 1 kiểu. Màu đen trung tính (không dùng màu family/amber) - tách biệt rõ với các badge tuổi/
// quan hệ khác, gợi màu áo chùng thâm của linh mục.
const PriestBadge = ({small, className = ''}) => {
    const t = useTranslate()
    return (
        <span
            className={`${small ? 'px-1 py-px text-4xs' : 'px-1.5 py-0.5 text-3xs'} rounded-full font-bold uppercase tracking-wide bg-gray-800 text-white whitespace-no-wrap ${className}`}>
            {t('priest')}
        </span>
    )
}

export default PriestBadge
